module.exports = __webpack_public_path__ + "media/assets/goldenTag-b4e39d07e39560e33d71f54789a2c616.png";